import { Component, OnInit } from '@angular/core';
import {
  SuperUserService,
  UserService
} from 'src/app/_services/generatedServices';
import { EventViewModel, UsersAuthoredEventsViewModel, CourseEventStatus } from 'src/app/_models/generatedModels';
import 'moment-timezone';
import { Enums } from 'src/app/_models/generatedEnums';
import { NavigationService } from 'src/app/_services/navigation-service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditAssessmentModalComponent } from 'src/app/superUser/courses/assessments/add-edit-assessment-modal.component';
import {
  ToasterService
} from "../../_services/toaster.service";

@Component({
  selector: 'bxl-my-live-events',
  templateUrl: 'my-live-events.component.html',
})
export class MyLiveEventsComponent implements OnInit {
  initialized = false;
  events: UsersAuthoredEventsViewModel[];
  CourseEventStatus = CourseEventStatus;
  CourseEventStatusEnum = Enums.CourseEventStatusEnum;
  timezone: string;
  submitComplete2: Promise<{}> | undefined;


  constructor(private userService: UserService, private modalService: NgbModal, private superUserService:SuperUserService, private toaster:ToasterService, private nav: NavigationService, public auth: AuthenticationService) {
    this.nav.pageTitle = 'My Live Events';
  }

  ngOnInit(): void {
    this.userService.getEventsListedByUser().subscribe((events) => {
      this.events = events;
      this.initialized = true;
    });
  }

  export(event:UsersAuthoredEventsViewModel) {
    this.submitComplete2 = new Promise((resetButton: any, reject) => {
      this.superUserService.exportPresenterData(event.id).subscribe(
        (result) => {
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(result);
          a.href = objectUrl;
          a.download = event.title + ' Presenter Data.xlsx';
          a.click();
          URL.revokeObjectURL(objectUrl);
          resetButton();
        },
        (error) => {
          resetButton();
          this.toaster.messageDialog(error.error, 'Error Exporting').subscribe();
        }
      );
    });
  }

  editCEUAssessment(model: UsersAuthoredEventsViewModel) {
    const modalRef = this.modalService.open(AddEditAssessmentModalComponent, { size: 'lg', windowClass: 'modal-full', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.courseEventId = model.id;
    modalRef.result.then(
      (result) => {

      },
      (reason) => {

      }
    );
    return;
  }
}
